import { cond, T } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getNumberProp, getProp, getStringProp } from '@mews/fp';
import { composeProps, createPropsExtender, createScopedSelector } from '@mews/framework';
import { ResourceCategoryType } from '@mews-commander/data-access';
import { getContainer } from '@mews-commander/legacy-app-instance';
import { stubNull, propNotNil } from '@mews-commander/utils';
import { getRateGroupNameVariants } from '@mews-commander/legacy-entities/src/ducks/rateGroups';
import { getRateNameVariants } from '@mews-commander/legacy-entities/src/ducks/rates';
import { getResourceCategoryNameVariants } from '@mews-commander/legacy-entities/src/ducks/resourceCategories';
import { moduleSelector } from '../module';

export const getRestrictionsModule = createScopedSelector({ parentSelector: moduleSelector, scopeName: 'serviceId' });

export const getColumnIndexFromProps = getNumberProp('columnIndex');
export const getRowIndexFromProps = getNumberProp('rowIndex');

const getLocalizedResourceCategoryTypeNameObject = createSelector(
    getContainer,
    getProp<ResourceCategoryType>()('resourceCategoryType'),
    (container, resourceCategoryType) => {
        const { appLocalizationComponent } = container();
        return { name: appLocalizationComponent.localizeEnum('ResourceCategoryType', resourceCategoryType) };
    }
);

export const getFirstConditionLabelVariants = cond([
    // @ts-expect-error $TSFixMeError: Type '(a1: unknown, a2: { [x: string]: unknown; }) => boolean' is not assignable to type '(val: unknown) => boolean'.
    [propNotNil('rateGroupId'), getRateGroupNameVariants],

    // @ts-expect-error $TSFixMeError: Type '(a1: unknown, a2: { [x: string]: unknown; }) => boolean' is not assignable to type '(val: unknown) => boolean'.
    [propNotNil('rateId'), getRateNameVariants],
    [T, stubNull],
]);

export const getSecondConditionLabelVariants = cond([
    [
        // @ts-expect-error $TSFixMeError: Type '(a1: unknown, a2: { [x: string]: unknown; }) => boolean' is not assignable to type '(val: unknown) => boolean'.
        propNotNil('resourceCategoryId'),

        // @ts-expect-error $TSFixMeError: Type 'Selector<unknown, { resourceCategoryId: string; }, PartialDeep<unknown>>' is not assignable to type '(val: unknown...
        composeProps(getResourceCategoryNameVariants, createPropsExtender('id', getStringProp('resourceCategoryId'))),
    ],

    // @ts-expect-error $TSFixMeError: Type '(a1: unknown, a2: { [x: string]: unknown; }) => boolean' is not assignable to type '(val: unknown) => boolean'.
    [propNotNil('resourceCategoryType'), getLocalizedResourceCategoryTypeNameObject],
    [T, stubNull],
]);
